import { render } from "./menu-button.vue?vue&type=template&id=f5e88150&scoped=true&ts=true&lang=pug"
import script from "./menu-button.vue?vue&type=script&lang=ts"
export * from "./menu-button.vue?vue&type=script&lang=ts"

import "./menu-button.vue?vue&type=style&index=0&id=f5e88150&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e88150"]])

export default __exports__